import { ApiResponse } from '@/shared/types';
import { axiosClient } from '@/shared/apis/config';
import { useQuery } from '@tanstack/react-query';
import { CustomQueryOptions } from '@/shared/types/global/react-query/query';
import { z } from 'zod';

// ================================ Start: DTO ================================
export type GetProjectSettingRequestType = {
  projectId: number;
};

export const GetProjectSettingResponseScheme = z.object({
  accountBrandTemplateId: z.number().optional(),
  voice: z.string().optional(),
  speedFactor: z.number().optional(),
  pitch: z.number().optional(),
  emotion: z.string().optional(),
  /** Gemini 전용 자연어 스타일 지시 (다른 벤더는 무시). */
  style: z.string().optional(),
});

export type ProjectSettingDto = z.infer<typeof GetProjectSettingResponseScheme>;

// ================================= End: DTO =================================

export type ResponseType = ApiResponse<ProjectSettingDto>;

export const getProjectSettingApi = async ({
  projectId,
}: GetProjectSettingRequestType) => {
  try {
    const response = await axiosClient.get<ResponseType>(
      `/v1.0/project/${projectId}/setting`,
    );

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const QueryKeyUseGetApi = 'getProjectSettingQueryKey' as const;

export const useGetProjectSettingApi = (
  { projectId }: GetProjectSettingRequestType,
  options?: CustomQueryOptions<ResponseType>,
) => {
  const { queryKey, ...rest } = options ?? {};

  return useQuery({
    queryKey: [QueryKeyUseGetApi, projectId, ...(queryKey ?? [])],
    queryFn: async () => await getProjectSettingApi({ projectId }),
    ...rest,
  });
};
